export default [
    "大部分情况下你可以使用鼠标右键进行快捷操作",
    "按住ctrl+F5可以强制刷新浏览器，这样您就不用手动清空缓存了",
    "在下拉菜单进行远程搜索的时候，可以按回车选择第一条返回的值",
]
